module.exports = __webpack_public_path__ + "static/media/icons-ic-arrow-callback.1d901dc8.svg";